import React, { useRef } from 'react'
import styled, { css } from 'styled-components'
import { InView } from 'react-intersection-observer'
import Spacer from '../../lib/spacer'
import BulletPoint from '../../common/bullet_point'
import Slots from './lib/slots'
import settingsImage from './img/settings.webp'
import { small, medium } from '../../lib/media_query'
import { FaWaveSquare, FaFlag } from 'react-icons/fa'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div`
    overflow-x: hidden; /** IE bug */
`

const ImageWrapper = styled.div`
    position: relative;

    ${small(css`
        top: 0px;
    `)};

    img {
        border-radius: 8px;
        padding: 10px;
    }
`

const SlotsWrapper = styled.div`
    position: absolute;
    right: -56px;
    top: -166px;

    ${medium(css`
        > div {
            transform: scale(0.8);
        }

        transform: translate(-50%, 0);
        left: 50%;
        right: unset;
    `)};

    ${small(css`
        > div {
            transform: scale(0.7);
        }
        transform: translate(-50%, 0);
        left: 50%;
        right: unset;
    `)};
`

export default () => {
    const slotsRef = useRef()
    const { t } = useTranslation(undefined, { keyPrefix: 'home.fineTuning' })

    return (
        <Wrapper>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="main grid-container">
                <div className="grid-x large-align-justify medium-align-center small-align-center">
                    <div className="cell text-center hide-for-large">
                        <h2 className="h1">{t('heading')}</h2>
                        <Spacer size={30} />
                        <p className="lead">{t('subheading')}</p>
                        <Spacer className="show-for-medium-only" size={30} />
                    </div>
                    <div className="cell small-11 medium-8 large-5">
                        <Spacer size={160} />
                        <InView
                            onChange={(inView) => inView && slotsRef.current.startAnimation()}
                            threshold={1}
                        >
                            <ImageWrapper>
                                <img className="box-shadow" src={settingsImage} alt={t('imageAlt')} />
                                <SlotsWrapper>
                                    <Slots ref={slotsRef} />
                                </SlotsWrapper>
                            </ImageWrapper>
                        </InView>
                        <Spacer size={100} className="hide-for-large" />
                    </div>
                    <div className="cell small-12 medium-12 large-5">
                        <div className="grid-x medium-align-justify">
                            <div className="cell show-for-large">
                                <h2 className="h1">{t('heading')}</h2>
                                <Spacer size={30} />
                                <p className="lead">{t('subheading')}</p>
                                <Spacer size={40} />
                            </div>
                            <BulletPoint
                                icon={FaWaveSquare}
                                className="cell small-12 medium-5 large-12"
                            >
                                <h4>{t('frequency.title')}</h4>
                                <p>{t('frequency.body')}</p>
                            </BulletPoint>
                            <BulletPoint
                                icon={FaFlag}
                                className="cell small-12 medium-5 large-12"
                            >
                                <h4>{t('remindersOnly.title')}</h4>
                                <p>{t('remindersOnly.body')}</p>
                            </BulletPoint>
                        </div>
                    </div>
                </div>
            </div>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
        </Wrapper>
    )
}
